import {
  keyBy, mapValues, each, filter, map, reduce, concat,
} from 'lodash';
import { ADD_ALL_OPPORTUNITY_TYPES, ADD_OPPORTUNITY_TYPE_MAPPINGS,
  ADD_ALL_OPPORTUNITY_STAGES, ADD_OPPORTUNITY_STAGE_MAPPINGS,
  ADD_ALL_OWNERS, ADD_INDUSTRY_FIELDS, ADD_ANNUAL_REVENUE_FIELDS,
  ADD_DO_NOT_CONTACT_FIELDS,
  ADD_EMPLOYEE_COUNT_FIELDS,
  ADD_ALL_SALE_REP_TYPE_MAPPINGS, UPDATE_SALE_REP_TYPE_MAPPING,
  ADD_ALL_SALE_REP_REGION_MAPPINGS, UPDATE_SALE_REP_REGION_MAPPING,
  VIEW_ORGANIZATION_USERS, DELETE_ORGANIZATION_USER,
  ADD_ORGANIZATION_USER, UPDATE_ORGANIZATION_USER,
  ADD_ALL_PRODUCTS, ADD_ALL_PRODUCT_MAPPINGS, UPDATE_PRODUCT_MAPPING,
  ADD_PRODUCT_SYNC_SETTINGS, ADD_AMOUNT_FIELDS,
  ADD_DEAL_TYPE_FIELDS, ADD_OUTCOME_TYPE_FIELDS, UPDATE_OWNER, ADD_CURRENCY_SYMBOLS, UPDATE_ROLE,
  ADD_ALL_COMPETITORS, ADD_ALL_ROLES, ADD_PRODUCT_FIELDS,
  UPDATE_CONVERSION_STAGE, ADD_ALL_CONVERSION_STAGES,
  FETCH_TV_PRODUCT_MAPPINGS, UPDATE_TV_PRODUCT_MAPPINGS,
  FETCH_TV_COLLECTOR_MAPPINGS, UPDATE_TV_COLLECTOR_MAPPINGS,
  ADD_FORECAST_CATEGORY_NAME_FIELDS,
  UPDATE_ORGANIZATION_USERS,
  ADD_CLOSE_DATE_FIELDS,
  FETCH_DISCOVERY_BOTS_SETTINGS,
  FETCH_FEEDBACK_REQUEST_REMINDER_EMAIL_SETTINGS,
  FETCH_EMAIL_ALERTS, UPDATE_EMAIL_ALERT, FETCH_EMAIL_ALERT_SUBSCRIPTION,
  FETCH_OPPORTUNITY_AUTOMATIONS,
  FETCH_ACCOUNT_AUTOMATIONS,
} from './SetupActions';

// Initial State
const initialState = {
  allTypes: [],
  typeMappings: [],

  allStages: [],
  stageMappings: [],

  allProducts: [],
  indexedProducts: {},
  productSearchableFields: [],

  allOwners: [],
  indexedOwners: {},
  ownerSearchableFields: [],

  allCompetitors: [],

  saleRepTypeMappings: [],
  saleRepRegionMappings: [],
  productMappings: [],

  productSyncSettings: {
    fields: [],
    use_product_table: false,
  },

  amountFields: {},
  possibleAmountFields: [],
  amountStages: [],

  dealTypeFields: [],
  outcomeTypeFields: [],
  industryFields: [],
  productFields: [],
  annualRevenueFields: [],
  employeeCountFields: [],
  doNotContactFields: [],
  forecastCategoryNameFields: [],
  closeDateFields: [],
  useProductTable: false,

  users: {
    items: [],
    meta: {},
  },
  currencySymbols: [],
  allRoles: [],
  conversionStages: [],

  tvProductMappings: {
    products: [],
    tvClients: {},
    useProductMappings: true,
    requireProducts: true,
    allowMultipleProducts: true,
    refs: {},
    dictionary: {},
  },
  tvCollectorMappings: {
    collectors: {},
    clients: [],
  },
  discoveryBotsSettings: {},
  feedbackRequestEmailSettings: {},

  opportunityAutomations: {
    automations: [],
    loading: true,
    loaded: false,
    error: null,
  },
  accountAutomations: {
    automations: [],
    loading: true,
    loaded: false,
    error: null,
  },
};

/*
function sortConversionStages(stages) {
  return orderBy(stages, [(stage) => {
    if (stage.conversion_stage === 'early') {
      return 0;
    } else if (stage.conversion_stage === 'late') {
      return 10;
    }
    return 1000;
  }, 'conversion_order']);
}
*/

const SetupReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_ALL_OPPORTUNITY_TYPES:
      return { ...state, allTypes: action.types };
    case ADD_OPPORTUNITY_TYPE_MAPPINGS:
      return { ...state, typeMappings: action.mappings };
    case ADD_ALL_OPPORTUNITY_STAGES:
      return { ...state, allStages: action.stages };
    case ADD_OPPORTUNITY_STAGE_MAPPINGS:
      return { ...state, stageMappings: action.mappings };
    case ADD_ALL_OWNERS: {
      const allOwners = action.owners;
      const { ownerSearchableFields } = action;
      const indexedOwners = keyBy(allOwners, 'user_id');
      return {
        ...state, allOwners, indexedOwners, ownerSearchableFields,
      };
    }
    case UPDATE_OWNER: {
      const { allOwners } = state;
      const newAllOwners = map(allOwners, (owner) => {
        if (owner._id === action.owner._id) {
          return { ...owner, ...action.owner };
        }
        return owner;
      });
      const indexedOwners = keyBy(newAllOwners, 'user_id');
      return { ...state, allOwners: newAllOwners, indexedOwners };
    }
    case UPDATE_ROLE: {
      const { allRoles } = state;
      const newAllRoles = map(allRoles, (role) => {
        if (role._id === action.role._id) {
          return { ...role, ...action.role };
        }
        return role;
      });
      return { ...state, allRoles: newAllRoles };
    }
    case ADD_PRODUCT_SYNC_SETTINGS: {
      return { ...state, productSyncSettings: action.settings };
    }
    case ADD_DEAL_TYPE_FIELDS: {
      return { ...state, dealTypeFields: action.fields };
    }
    case ADD_OUTCOME_TYPE_FIELDS: {
      return { ...state, outcomeTypeFields: action.fields };
    }
    case ADD_INDUSTRY_FIELDS: {
      return { ...state, industryFields: action.fields };
    }
    case ADD_ANNUAL_REVENUE_FIELDS: {
      return { ...state, annualRevenueFields: action.fields };
    }
    case ADD_DO_NOT_CONTACT_FIELDS: {
      return { ...state, doNotContactFields: action.fields };
    }
    case ADD_FORECAST_CATEGORY_NAME_FIELDS: {
      return { ...state, forecastCategoryNameFields: action.fields };
    }
    case ADD_EMPLOYEE_COUNT_FIELDS: {
      return { ...state, employeeCountFields: action.fields };
    }
    case ADD_PRODUCT_FIELDS: {
      return { ...state, productFields: action.fields, useProductTable: action.useProductTable };
    }
    case ADD_CURRENCY_SYMBOLS: {
      return { ...state, currencySymbols: action.currencies };
    }
    case ADD_CLOSE_DATE_FIELDS: {
      return { ...state, closeDateFields: action.fields };
    }
    case ADD_AMOUNT_FIELDS: {
      const newState = { ...state, amountFields: action.fields };
      if (action.stages) {
        newState.amountStages = action.stages;
      }
      if (action.possibleAmountFields) {
        newState.possibleAmountFields = action.possibleAmountFields;
      }
      return newState;
    }
    case ADD_ALL_SALE_REP_TYPE_MAPPINGS:
      return { ...state, saleRepTypeMappings: action.mappings };
    case UPDATE_SALE_REP_TYPE_MAPPING: {
      const newMappings = state.saleRepTypeMappings.map((mapping) => {
        if (mapping._id === action.mapping._id) {
          return action.mapping;
        }
        return mapping;
      });
      return { ...state, saleRepTypeMappings: newMappings };
    }
    case ADD_ALL_PRODUCTS:
      return {
        ...state,
        allProducts: action.products,
        indexedProducts: keyBy(action.products, 'product_id'),
        productSearchableFields: action.productSearchableFields,
      };
    case ADD_ALL_PRODUCT_MAPPINGS:
      return { ...state, productMappings: action.mappings };
    case UPDATE_PRODUCT_MAPPING: {
      const newMappings = state.productMappings.map((mapping) => {
        if (mapping._id === action.mapping._id) {
          return action.mapping;
        }
        return mapping;
      });
      return { ...state, productMappings: newMappings };
    }
    case ADD_ALL_SALE_REP_REGION_MAPPINGS:
      return { ...state, saleRepRegionMappings: action.mappings };
    case DELETE_ORGANIZATION_USER: {
      const { users } = state;
      const items = filter(users.items, item => item._id !== action.id);
      return { ...state, users: { ...users, items } };
    }
    case VIEW_ORGANIZATION_USERS: {
      return { ...state, users: action.users };
    }
    case ADD_ORGANIZATION_USER: {
      const { users } = state;
      const items = users.items.concat({ ...action.user });
      return { ...state, users: { ...users, items } };
    }
    case UPDATE_ORGANIZATION_USER: {
      const { users } = state;
      const items = users.items.map((item) => {
        if (item._id === action.user._id) {
          return { ...action.user };
        }
        return item;
      });
      return { ...state, users: { ...users, items } };
    }
    case UPDATE_ORGANIZATION_USERS: {
      const { users } = action;
      const indexed = keyBy(users, '_id');

      const items = map(state.users.items, (item) => {
        if (indexed[item._id]) {
          return { ...item, ...indexed[item._id] };
        }
        return item;
      });
      return { ...state, users: { ...users, items } };
    }
    case UPDATE_SALE_REP_REGION_MAPPING: {
      const newMappings = state.saleRepRegionMappings.map((mapping) => {
        if (mapping._id === action.mapping._id) {
          return action.mapping;
        }
        return mapping;
      });
      return { ...state, saleRepRegionMappings: newMappings };
    }
    case ADD_ALL_ROLES: {
      return { ...state, allRoles: action.roles };
    }
    case ADD_ALL_COMPETITORS: {
      return { ...state, allCompetitors: action.competitors };
    }
    case ADD_ALL_CONVERSION_STAGES: {
      return { ...state, conversionStages: action.stages };
    }
    case UPDATE_CONVERSION_STAGE: {
      const { conversionStages } = state;
      const { id, stage } = action;
      const newStages = conversionStages.map((s) => {
        if (s.stage_id === id) {
          return stage;
        }
        return s;
      });
      return { ...state, conversionStages: newStages };
    }
    case FETCH_TV_PRODUCT_MAPPINGS: {
      const { tvClients, products, useProductMappings, requireProducts, allowMultipleProducts } = action;
      const refs = reduce(tvClients, (clients, tvClient) => {
        clients[tvClient.id] = reduce(tvClient.programs, (programs, program) => {
          programs[program.id] = reduce(program.products, (prods, product) => {
            prods[product.id] = product.name;
            return prods;
          }, {});
          return programs;
        }, {});
        return clients;
      }, {});
      const indexedTVProducts = {};
      reduce(tvClients, (items, client) => {
        indexedTVProducts[client.id] = {};
        each(client.programs, (program) => {
          indexedTVProducts[client.id][program.id] = {};
          each(program.products, (product) => {
            const newProduct = {
              ...product,
              client_id: client.id,
              client_name: client.name,
              program_id: program.id,
              program_name: program.name,
              program_type: program.type_name,
            };
            indexedTVProducts[client.id][program.id][product.id] = newProduct;
            items.push(newProduct);
          });
        });
        return items;
      }, []);
      let dictionary = {};
      if (useProductMappings) {
        dictionary = reduce(products, (items, product) => {
          if (product.type !== 'tv-product') {
            each(product.product_ids, (productId) => {
              if (!items[productId]) {
                items[productId] = [];
              }
              each(product.mappings, (programs, clientId) => {
                each(programs, (tvProductId, programId) => {
                  if (indexedTVProducts[clientId] && indexedTVProducts[clientId][programId] && indexedTVProducts[clientId][programId][tvProductId]) {
                    items[productId].push(indexedTVProducts[clientId][programId][tvProductId]);
                  }
                });
              });
            });
          }
          return items;
        }, {});
      } else {
        const tsProducts = filter(products, prod => prod.type === 'inline-product' || prod.type === 'product');
        const tvProducts = filter(products, prod => prod.type === 'tv-product');

        dictionary = reduce([...tsProducts, { id: '__ALL__' }], (items, product) => {
          const productId = product.id;
          if (!items[productId]) {
            items[productId] = [];
          }

          each(tvProducts, (tvProduct) => {
            each(tvProduct.mappings, (programs, clientId) => {
              each(programs, (tvProductId, programId) => {
                if (indexedTVProducts[clientId] && indexedTVProducts[clientId][programId] && indexedTVProducts[clientId][programId][tvProductId]) {
                  items[productId].push(indexedTVProducts[clientId][programId][tvProductId]);
                }
              });
            });
          });
          return items;
        }, {});
      }
      return {
        ...state,
        tvProductMappings: {
          requireProducts,
          products, tvClients, refs, dictionary,
          useProductMappings,
          allowMultipleProducts,
        },
      };
    }
    case UPDATE_TV_PRODUCT_MAPPINGS: {
      const { results, params } = action;
      const clientId = results.client_id;
      const programId = results.program_id;
      const requestMappings = filter(params.mappings, mapping => mapping.tv_product_id === null || mapping.tv_product_id === undefined);
      const updatedMappings = keyBy(concat(results.mappings, requestMappings), 'ts_product_id');
      /*
      const newProducts = reduce(state.tvProductMappings.products, (items, product) => {
        if (updatedMappings[product.id]) {
          const newProduct = cloneDeep(product);
          if (!newProduct.mappings) {
            newProduct.mappings = {};
          }
          if (!newProduct.mappings[clientId]) {
            newProduct.mappings[clientId] = {};
          }
          newProduct.mappings[clientId][programId] = updatedMappings[product.id].tv_product_id;
          items.push(newProduct);
        } else {
          items.push(product);
        }
        return items;
      }, []);
      */

      each(state.tvProductMappings.products, (product) => {
        if (updatedMappings[product.id]) {
          const newProduct = product;
          if (!newProduct.mappings) {
            newProduct.mappings = {};
          }
          if (!newProduct.mappings[clientId]) {
            newProduct.mappings[clientId] = {};
          }
          newProduct.mappings[clientId][programId] = updatedMappings[product.id].tv_product_id;
        }
      });

      return {
        ...state,
        tvProductMappings: {
          ...state.tvProductMappings,
          useProductMappings: results.useProductMappings,
          // products: newProducts,
        },
      };
    }
    case FETCH_TV_COLLECTOR_MAPPINGS: {
      const { clients, collectors } = action;
      return { ...state, tvCollectorMappings: { collectors, clients } };
    }
    case UPDATE_TV_COLLECTOR_MAPPINGS: {
      const { results } = action;
      const { tvCollectorMappings } = state;
      const newClients = reduce(tvCollectorMappings.clients, (items, client) => {
        if (client.id === results.client_id) {
          const newClient = {
            ...client,
            programs: reduce(client.programs, (subItems, program) => {
              if (program.id === results.program_id) {
                subItems.push({
                  ...program,
                  [`${results.type}_collector_id`]: results.collector_id,
                });
              } else {
                subItems.push(program);
              }
              return subItems;
            }, []),
          };
          items.push(newClient);
        } else {
          items.push(client);
        }
        return items;
      }, []);
      return {
        ...state,
        tvCollectorMappings: {
          ...tvCollectorMappings,
          clients: newClients,
        },
      };
    }
    case FETCH_DISCOVERY_BOTS_SETTINGS: {
      const { settings } = action;
      return {
        ...state,
        discoveryBotsSettings: settings,
      };
    }
    case FETCH_FEEDBACK_REQUEST_REMINDER_EMAIL_SETTINGS: {
      const { settings, emailType } = action;
      return {
        ...state,
        feedbackRequestEmailSettings: {
          ...state.feedbackRequestEmailSettings,
          [emailType]: settings,
        },
      };
    }
    case FETCH_EMAIL_ALERTS: {
      const { emailAlerts } = action;
      const indexedEmailAlerts = emailAlerts?.reduce((acc, emailAlert) => {
        acc[emailAlert.type] = emailAlert;
        return acc;
      }, {}) || {};
      return {
        ...state,
        indexedEmailAlerts,
      };
    }
    case UPDATE_EMAIL_ALERT: {
      const { emailAlert } = action;
      const indexedEmailAlerts = {
        ...(state.indexedEmailAlerts || {}),
        [emailAlert.type]: emailAlert,
      };
      return {
        ...state,
        indexedEmailAlerts,
      };
    }
    case FETCH_EMAIL_ALERT_SUBSCRIPTION: {
      const { emailAlertSubscription } = action;
      return {
        ...state,
        emailAlertSubscription,
      };
    }
    case FETCH_OPPORTUNITY_AUTOMATIONS: {
      const { automations, error, loading, loaded } = action;
      return {
        ...state,
        opportunityAutomations: {
          automations, error, loading, loaded,
        },
      };
    }
    case FETCH_ACCOUNT_AUTOMATIONS: {
      const { automations, error, loading, loaded } = action;
      return {
        ...state,
        accountAutomations: {
          automations, error, loading, loaded,
        },
      };
    }
    default:
      return state;
  }
};

/* Selectors */
export const getAllTypes = state => state.setup.allTypes;
export const getTypeMappings = state => state.setup.typeMappings;
export const getAllStages = state => state.setup.allStages;
export const getStageMappings = state => state.setup.stageMappings;
export function getTranslatedStageMappings(state) {
  const maps = mapValues(keyBy(state.setup.stageMappings, s => s.label), s => s.items);
  const results = {};
  each(maps, (items, key) => {
    each(items, (item) => {
      results[item] = key;
    });
  });
  return results;
}
export const getAllOwners = state => state.setup.allOwners;
export const getIndexedOwners = state => state.setup.indexedOwners;
export const getAllSaleRepTypeMappings = state => state.setup.saleRepTypeMappings;
export const getAllSaleRepRegionMappings = state => state.setup.saleRepRegionMappings;
export const getOrganizationUsers = state => state.setup.users;

export const getAllProducts = state => state.setup.allProducts;
export const getIndexedProducts = state => state.setup.indexedProducts;

export const getAllProductMappings = state => state.setup.productMappings;
export const getProductSyncSettings = state => state.setup.productSyncSettings;

export const getAllAmountFields = state => state.setup.amountFields;
export const getPossibleAmountFields = state => state.setup.possibleAmountFields;
export const getAmountStages = state => state.setup.amountStages;

export const getAllDealTypeFields = state => state.setup.dealTypeFields;
export const getAllOutcomeTypeFields = state => state.setup.outcomeTypeFields;
export const getAllIndustryFields = state => state.setup.industryFields;
export const getAllProductFields = state => state.setup.productFields;
export const getAllAnnualRevenueFields = state => state.setup.annualRevenueFields;
export const getAllEmployeeCountFields = state => state.setup.employeeCountFields;
export const getAllCloseDateFields = state => state.setup.closeDateFields;
export const getAllDoNotContactFields = state => state.setup.doNotContactFields;

export const getCurrencySymbols = state => state.setup.currencySymbols;

export const getOwnerSearchableFields = state => state.setup.ownerSearchableFields;
export const getProductSearchableFields = state => state.setup.productSearchableFields;

export const getAllCompetitors = state => state.setup.allCompetitors;
export const getAllRoles = state => state.setup.allRoles;
export const getConversionStages = state => state.setup.conversionStages;

export const getTVProductMappings = (state) => {
  if (state.setup.tvProductMappings) {
    return state.setup.tvProductMappings.products;
  }
  return [];
};

export const getTVUseProductMappings = (state) => {
  if (state.setup.tvProductMappings) {
    return state.setup.tvProductMappings.useProductMappings;
  }
  return true;
};

export const getTVRequireProducts = (state) => {
  if (state.setup.tvProductMappings) {
    return state.setup.tvProductMappings.requireProducts;
  }
  return true;
};

export const getTVAllowMultipleProducts = (state) => {
  if (state.setup.tvProductMappings) {
    return state.setup.tvProductMappings.allowMultipleProducts;
  }
  return true;
};

export const getTVProductRefs = (state) => {
  if (state.setup.tvProductMappings) {
    return state.setup.tvProductMappings.refs;
  }
  return {};
};

export const getTVProductClients = (state) => {
  if (state.setup.tvProductMappings) {
    return state.setup.tvProductMappings.tvClients;
  }
  return [];
};
export const getTVProductDictionary = (state) => {
  if (state.setup.tvProductMappings) {
    return state.setup.tvProductMappings.dictionary;
  }
  return {};
};

export const getTVCollectorMappings = (state) => {
  if (state.setup.tvCollectorMappings) {
    return state.setup.tvCollectorMappings.clients;
  }
  return [];
};
export const getTVCollectorRefs = (state) => {
  if (state.setup.tvCollectorMappings) {
    return state.setup.tvCollectorMappings.collectors;
  }
  return [];
};

export const getDiscoveryBotSettings = state => state.setup.discoveryBotsSettings || {};

export const getFeedbackRequestEmailSettings = (state, emailType) => (state.setup.feedbackRequestEmailSettings || {})[emailType] || {};

export const getEmailAlert = (state, type) => (type && typeof type === 'string' && (state.setup.indexedEmailAlerts || {})[type]) || null;

export const getOpportunityAutomations = state => state.setup.opportunityAutomations || {};
export const getAccountAutomations = state => state.setup.accountAutomations || {};

// Export Reducer
export default SetupReducer;
